import React, { createContext, useContext, useReducer } from 'react';
import { getLocalStorage, getSessionStorage } from 'utility/browserStorageUtil';
import ActionTypes from './actions';
import reducerBooking from './reducer';

export enum TypeForDialog {
  PRECAUTION_FOR_BODY = 'PRECAUTION_FOR_BODY',
  ADULT_STUDENT_USING_SERVICE = 'ADULT_STUDENT_USING_SERVICE',
  PAYMENT_COMPLETED = 'PAYMENT_COMPLETED',
  RECEIVED_APPOINTMENT_DATE = 'RECEIVED_APPOINTMENT_DATE',
  PRECAUTION_BEFORE_APPLICATION = 'PRECAUTION_BEFORE_APPLICATION',
}

export enum StatusBooking {
  AVAILABLE_BOOKING = 'AVAILABLE_BOOKING',
  CALL_BEFORE_BOOKING = 'CALL_BEFORE_BOOKING',
  CAN_NOT_BOOKING = 'CAN_NOT_BOOKING',
}

export type THandleChangeSearch = Pick<InitialStateType,
'chosenDesiredCare' |
'chosenCourse' |
'chosenArea' |
'chosenStore'|
'chosenDesiredCareName'|
'chosenCourseName'|
'chosenAreaName'|
'chosenStoreName'|
'chosenCourseAcceptRequestReservation'
>

export type THandleChangeInfoBooking = Pick<InitialStateType,
'customerNumberBooking' |
'contractCourseNameBooking'|
'orgNameBooking'|
'birthDateBooking'|
'emailBooking' |
'reservationIdBooking' |
'transactionIdBooking' |
'companyCodeBooking' |
'reservationTypeBooking'
>

export interface IHandleChangeProps {
  name: string,
  value: InitialStateType[keyof InitialStateType]
}
export interface ISelectOption {
  id: string,
  text: string,
}

export interface IDefaultValueSearch{
  chosenDesiredCare: string,
  chosenCourse: string,
  chosenArea: string,
  chosenStore: string,
}



export type InitialStateType = {
  companyCode: string,
  originalReservationId: string,
   // Search Booking
  chosenDesiredCare: string;
  chosenCourse: string;
  chosenArea: string;
  chosenStore: string;
  chosenDesiredCareName?: string;
  chosenCourseName?: string;
  chosenAreaName?: string;
  chosenStoreName?: string;
  // リクエスト予約で受け付けるコース判定（true: 仮予約 / false: 即時予約）
  chosenCourseAcceptRequestReservation?: boolean;
  // Desired Time Booking
  desiredTime: string;
  status: keyof typeof StatusBooking,
  // Info Booking
  customerNumberBooking:string,
  contractCourseNameBooking:string,
  orgNameBooking:string,
  birthDateBooking:string,
  emailBooking:string,
  reservationIdBooking:string,
  transactionIdBooking:string,
  companyCodeBooking: string,
  reservationTypeBooking: string,
  // Dialog
  isDialogOpen: boolean;
  typeDialog: keyof typeof TypeForDialog;
  // Functions
  handleChangeSearch: (search: THandleChangeSearch) => void;
  handleChange: ({ name, value }: IHandleChangeProps) => void;
  handleChangeInfoBooking: (booking: THandleChangeInfoBooking) => void;
  handleDisplayDialog: ({ typeDialog }: {typeDialog: InitialStateType['typeDialog']}) => void;
  handleHideDialog: () => void;
  handleResetContext: () => void;
}

const initialStateBooking: InitialStateType = {
  companyCode: '',
  originalReservationId: '',
  // Search Booking
  chosenDesiredCare: '',
  chosenCourse: '',
  chosenArea: '',
  chosenStore: '',
  chosenDesiredCareName: '',
  chosenCourseName: '',
  chosenAreaName: '',
  chosenStoreName: '',
  chosenCourseAcceptRequestReservation: false,
  // Desired Time Booking
  desiredTime: '',
  status: StatusBooking.CAN_NOT_BOOKING,
  // Info Booking
  customerNumberBooking: getLocalStorage('customerId') || '',
  contractCourseNameBooking: '',
  orgNameBooking: '',
  birthDateBooking: '',
  emailBooking: '',
  reservationIdBooking: '',
  transactionIdBooking: '',
  companyCodeBooking: '',
  reservationTypeBooking: '',
  // Dialog
  isDialogOpen: false,
  typeDialog: TypeForDialog.ADULT_STUDENT_USING_SERVICE,

  // Functions
  handleChangeSearch: () => null,
  handleDisplayDialog: () => null,
  handleChangeInfoBooking: () => null,
  handleHideDialog: () => null,
  handleChange: () => null,
  handleResetContext: () => null,
};

const ReservationBookingOnlineContext = createContext<InitialStateType>(initialStateBooking);

const ReservationBookingOnlineContextProvider: React.FC<{ originalReservationId?: string }> = ({ children, originalReservationId }) => {
  const [state, dispatch] = useReducer(reducerBooking, {
    ...initialStateBooking,
    originalReservationId: originalReservationId || '',
  });

  // HandleChange for Select, Input
  const handleChangeSearch = (payload: THandleChangeSearch) => {
    dispatch({
      type: ActionTypes.HANDLE_CHANGE_SEARCH,
      payload,
    });
  };

  const handleChangeInfoBooking = (payload: THandleChangeInfoBooking) => {
    dispatch({
      type: ActionTypes.HANDLE_CHANGE_INFO_BOOKING,
      payload,
    });
  };

  const handleChange = ({ name, value }: IHandleChangeProps) => {
    dispatch({
      type: ActionTypes.HANDLE_CHANGE,
      payload: {
        name,
        value,
      },
    });
  };

  const handleResetContext = () => {
    dispatch({
      type: ActionTypes.HANDLE_RESET_CONTEXT,
      payload: initialStateBooking,
    });
  };

  // Handle Dialog
  const handleDisplayDialog = ({ typeDialog }: {typeDialog: InitialStateType['typeDialog']}) => {
    dispatch({
      type: ActionTypes.DISPLAY_DIALOG,
      payload: {
        typeDialog,
      },
    });
  };
  const handleHideDialog = () => {
    dispatch({
      type: ActionTypes.HIDE_DIALOG,
    });
  };

  return (
    <ReservationBookingOnlineContext.Provider value={{
      ...state, handleChange, handleChangeSearch, handleChangeInfoBooking, handleDisplayDialog, handleHideDialog, handleResetContext,
    }}
    >
      {children}
    </ReservationBookingOnlineContext.Provider>
  );
};

const useReservationBookingOnlineContext = () => {
  const context = useContext(ReservationBookingOnlineContext);
  if (!context) {
    throw new Error('That no context');
  }
  return context;
};

export { ReservationBookingOnlineContextProvider, useReservationBookingOnlineContext };
